export function fplx(code) {
  if (code == "004") {
    return "增值税专用发票";
  } else if (code == "007") {
    return "增值税普通发票";
  } else if (code == "025") {
    return "卷式发票";
  } else if (code == "026") {
    return "电子普通发票";
  } else if (code == "005") {
    return "机动车发票";
  } else if (code == "006") {
    return "二手车销售统一发票";
  } else if (code == "028") {
    return "增值税电子专用发票";
  }
}

export function inventoryTypeFilter(type) {
  //存货类别filter
  if (type == 1) {
    return "原材料";
  } else if (type == 2) {
    return "库存商品";
  } else if (type == 3) {
    return "半成品";
  } else if (type == 4) {
    return "委托加工物资";
  } else if (type == 5) {
    return "周转材料";
  } else if (type == 6) {
    return "包装物";
  } else if (type == 7) {
    return "消耗性生物资产";
  } else if (type == 8) {
    return "工程物资";
  } else if (type == 9) {
    return "开发产品";
  } else if (type == 10) {
    return "发出产品";
  } else if (type == 11) {
    return "其他";
  }
}

export function inventoryCategoryFilter(type) {
  //存货类型filter
  if (type == 1) {
    return "初始化导入";
  } else if (type == 2) {
    return "进项入库-进项发票录入";
  } else if (type == 3) {
    return "暂估入库";
  } else if (type == 4) {
    return "生产商品入库(生产结转)";
  } else if (type == 6) {
    return "领料出库(生产结转)";
  } else if (type == 7) {
    return "商品结转出库(贸易结转)";
  } else if (type == 8) {
    return "抵消销项卖出(特殊)";
  } else if (type == 9) {
    return "销项卖出-销项发票录入";
  } else if (type == 10) {
    return "手工出库";
  } else if (type == 11) {
    return "手工入库";
  } else if (type == 12) {
    return "凭证关联出库";
  } else if (type == 13) {
    return "凭证关联入库";
  } else if (type == 31) {
    return "暂估回冲";
  } else if (type == 91) {
    return "销项回冲";
  }
}

export function VoucherSourceFilter(type) {
  //凭证来源filter
  if (type == "1") {
    return "进项";
  } else if (type == "2") {
    return "销项";
  } else if (type == "3") {
    return "费用";
  } else if (type == "4") {
    return "现金";
  } else if (type == "5") {
    return "票据";
  } else if (type == "6") {
    return "银行";
  } else if (type == "7") {
    return "工资";
  } else if (type == "8") {
    return "结转损益";
  } else if (type == "9") {
    return "计提税金";
  } else if (type == "10") {
    return "资产";
  } else if (type == "12") {
    return "存货结转";
  } else if (type == "13") {
    return "暂估回冲";
  } else if (type == "14") {
    return "暂估入库";
  } else if (type == "20") {
    return "进项认证";
  } else if (type == "30") {
    return "固定资产清理";
  } else if (type == "40") {
    return "汇兑损益";
  } else if (type == "100") {
    return "年末结转利润";
  } else if (type == "手工录入") {
    return "手工录入";
  }
}

export function tableNameFilter(type, accountSystem) {
  // 使用对象映射来替代 if-else 结构
  const mapping = {
    kj_lrb: {
      民办非: "业务活动表",
      农业合作社: "盈余及盈余分配表",
      default: "利润表",
    },
    kj_zcfz: "资产负债表",
    gs_vat: "增值税及附加税一般纳税人申报表",
    gs_small_vat: "小规模增值税纳税及附加税申报表",
    gs_deed: "财产和行为税纳税申报表",
    gs_tax_quarter: "企业所得税申报表",
    gs_gs: "综合所得个人所得税",
    gs_fjs: "附加税",
    gs_whsyjsfsbbygz: "文化事业建设费申报表",
    gs_stamp_duty_item: "印花税纳税申报表", // 合并重复项
    gs_xfs: "消费税",
    gs_cbj: "残疾人就业保障金申报表",
    gs_ghjf: "工会经费", // 合并重复项
    gs_fcs: "房产税土地税",
    gs_fssr: "非税收入",
    gs_sl: "水利建设专项收入",
    gs_ljcl: "城市生活垃圾处置费",
    gs_qtsr: "工会经费", // 合并重复项
    gs_gs_one: "个人生产经营所得(查账)",
    gs_gs_hd: "个人生产经营所得(核定征收)",
    kj_xjllb: "现金流量表",
    gs_sb: "单位社会保险费日常申报(全责)",
    gs_cwbb: "财务报表",
    gs_tax_dqde: "个人所得税(定期定额)",
    kj_zy_cyqybdb: "成员权益变动表",
    kj_zy_yyfpb: "盈余及盈余分配表",
  }
  // 根据 type 和 accountSystem 返回相应的报表名称
  if (mapping[type] instanceof Object) {
    return mapping[type][accountSystem] || mapping[type].default
  } else {
    return mapping[type]
  }
}

export function taxPayerTypeFilter(type) {
  if (type == "1") {
    return "小规模纳税人";
  } else if (type == "2") {
    return "一般纳税人";
  }
}

// 扣款状态
export function setUpStatusKk(type) {
  if (type == "0" || type == "") {
    return "未扣款";
  } else if (type == "1") {
    return "排队中";
  } else if (type == "2") {
    return "扣款中";
  } else if (type == "3") {
    return "扣款成功";
  } else if (type == "4") {
    return "无需扣款";
  } else if (type == "5") {
    return "扣款异常";
  }
}

// 申报状态
export function setUpStatusSb(type) {
  if (type == "0" || type == "") {
    return "未申报";
  } else if (type == "1") {
    return "排队中";
  } else if (type == "2") {
    return "申报中";
  } else if (type == "3") {
    return "申报完成";
  } else if (type == "4") {
    return "申报异常";
  } else if (type == "5") {
    return "税局处理中";
  } else if (type == "6") {
    return "已申报过";
  }
}

// 采集状态
export function setUpStatusCj(type) {
  if (type == "0") {
    return "未采集";
  } else if (type == "1") {
    return "排队中";
  } else if (type == "2") {
    return "采集中";
  } else if (type == "3") {
    return "采集完成";
  } else if (type == "4") {
    return "采集失败";
  } else if (type == "5") {
    return "异常";
  }
}

// 导入状态
export function setUpStatusImport(type) {
  if (type == "0") {
    return "未导入";
  } else if (type == "1") {
    return "排队中";
  } else if (type == "2") {
    return "导入中";
  } else if (type == "3") {
    return "导入完成";
  } else if (type == "4") {
    return "导入失败";
  } else if (type == "5") {
    return "错误";
  }
}

// 匹配状态
export function setUpStatusMatch(type) {
  if (type == "0") {
    return "未匹配";
  } else if (type == "1") {
    return "排队中";
  } else if (type == "2") {
    return "匹配中";
  } else if (type == "3") {
    return "匹配完成";
  } else if (type == "4") {
    return "匹配失败";
  } else if (type == "5") {
    return "错误";
  }
}
// 采集状态
export function setUpStatusQY(type) {
  if (type == "0") {
    return "未迁移";
  } else if (type == "1") {
    return "排队中";
  } else if (type == "2") {
    return "迁移中";
  } else if (type == "3") {
    return "迁移完成";
  } else if (type == "4") {
    return "迁移失败";
  } else if (type == "5") {
    return "异常";
  }
}
// 个税申报状态
export function setUpStatusGsSb(status, type) {
  if (status == 0 || status == "") {
    return "未申报";
  } else if (status == 1) {
    return "排队中";
  } else if (status == 2) {
    return "申报中";
  } else if (status == 4) {
    return "失败";
  } else {
    if (type == "3") {
      return "申报超时失败";
    }
    if (type == "2") {
      return "申报处理中";
    } else if (type == "4") {
      return "客户端未启动失败";
    } else if (type == "5") {
      return "申报异常";
    } else if (type == "6") {
      return "申报失败";
    } else if (type == "7") {
      return "申报成功，待缴款";
    } else if (type == "8") {
      return "自动检查中";
    } else if (type == "10") {
      return "申报成功，无需缴款";
    } else if (type == "11") {
      return "扣款中";
    } else if (type == "12") {
      return "扣款异常";
    } else if (type == "13") {
      return "申报成功，扣款成功";
    } else if (type == "14") {
      return "已申报过";
    } else if (type == "20") {
      return "申报成功";
    } else {
      return "未知状态";
    }
  }
}

export function setUpStatusGsKk(status, type) {
  if (status == 0 || status == "") {
    return "未开始";
  } else if (status == 1) {
    return "排队中";
  } else if (status == 2) {
    return "扣款中";
  } else if (status == 4) {
    return "失败";
  } else {
    if (type == "3") {
      return "申报超时失败";
    }
    if (type == "2") {
      return "申报处理中";
    } else if (type == "4") {
      return "客户端未启动失败";
    } else if (type == "5") {
      return "申报异常";
    } else if (type == "6") {
      return "申报失败";
    } else if (type == "7") {
      return "申报成功，待缴款";
    } else if (type == "8") {
      return "自动检查中";
    } else if (type == "10") {
      return "申报成功，无需缴款";
    } else if (type == "11") {
      return "扣款中";
    } else if (type == "12") {
      return "扣款异常";
    } else if (type == "13") {
      return "申报成功，扣款成功";
    } else if (type == "14") {
      return "已申报过";
    } else if (type == "20") {
      return "申报成功";
    } else {
      return "未知状态";
    }
  }
}

export function setUpStatusGsIconSb(status, type) {
  if (status == 0 || status == "") {
    return "iconfont icon-gantanhao";
  } else if (status == 1) {
    return "iconfont icon-info";
  } else if (status == 2) {
    return "iconfont icon-info";
  } else if (status == 4) {
    return "iconfont icon-cuowu";
  } else {
    if (type == "3") {
      return "iconfont icon-cuowu";
    } else if (type == "2") {
      return "iconfont icon-info";
    } else if (type == "4") {
      return "iconfont icon-cuowu";
    } else if (type == "5") {
      return "iconfont icon-cuowu";
    } else if (type == "6") {
      return "iconfont icon-cuowu";
    } else if (type == "7") {
      return "iconfont icon-info";
    } else if (type == "8") {
      return "iconfont icon-info";
    } else if (type == "10") {
      return "iconfont icon-duihao";
    } else if (type == "11") {
      return "iconfont icon-info";
    } else if (type == "12") {
      return "iconfont icon-cuowu";
    } else if (type == "13") {
      return "iconfont icon-duihao";
    } else if (type == "14") {
      return "iconfont icon-duihao";
    }
  }
}

export function setUpStatusGsWordSb(status, type) {
  if (status == 0 || status == "") {
    return "wsb";
  } else if (status == 1) {
    return "sbz";
  } else if (status == 2) {
    return "sbz";
  } else if (status == 4) {
    return "sbyc2";
  } else {
    if (type == "3") {
      return "sbyc2";
    } else if (type == "2") {
      return "sbz";
    } else if (type == "4") {
      return "sbyc2";
    } else if (type == "5") {
      return "sbyc2";
    } else if (type == "6") {
      return "sbyc2";
    } else if (type == "7") {
      return "sbz";
    } else if (type == "8") {
      return "sbz";
    } else if (type == "10") {
      return "sbcg2";
    } else if (type == "11") {
      return "sbz";
    } else if (type == "12") {
      return "sbyc2";
    } else if (type == "13") {
      return "sbcg2";
    } else if (type == "14") {
      return "sbcg2";
    }
  }
}

// 税种申报 申报任务结果状态
export function batchSendSb(status, type) {
  if (status == 0 || status == "") {
    return "未申报";
  } else if (status == 1) {
    return "排队中";
  } else if (status == 2) {
    return "申报中";
  } else if (status == 4) {
    return "失败";
  } else {
    if (type == "2") {
      return "申报成功无需扣款";
    } else if (type == "3") {
      return "申报失败";
    } else if (type == "4") {
      return "提交金三处理中";
    } else if (type == "5") {
      return "申报成功,待缴款";
    } else if (type == "6") {
      return "申报成功,已缴款";
    } else if (type == "20") {
      return "已申报过，无需扣款";
    } else if (type == "21") {
      return "已申报过，待缴款";
    } else if (type == "22") {
      return "已申报过，已缴款";
    } else {
      return "未知状态";
    }
  }
}

export function batchSendIconSb(status, type) {
  if (status == 0 || status == "") {
    return "iconfont icon-gantanhao";
  } else if (status == 1) {
    return "iconfont icon-info";
  } else if (status == 2) {
    return "iconfont icon-info";
  } else if (status == 4) {
    return "iconfont icon-cuowu";
  } else {
    if (type == "2") {
      return "iconfont icon-duihao";
    } else if (type == "3") {
      return "iconfont icon-cuowu";
    } else if (type == "4") {
      return "iconfont icon-info";
    } else if (type == "5") {
      return "iconfont icon-duihao";
    } else if (type == "6") {
      return "iconfont icon-duihao";
    } else if (type == "20") {
      return "iconfont icon-duihao";
    } else if (type == "21") {
      return "iconfont icon-duihao";
    } else if (type == "22") {
      return "iconfont icon-duihao";
    } else {
      return "未知状态";
    }
  }
}

export function batchSendWordSb(status, type) {
  if (status == 0 || status == "") {
    return "wsb";
  } else if (status == 1) {
    return "sbz";
  } else if (status == 2) {
    return "sbz";
  } else if (status == 4) {
    return "sbyc2";
  } else {
    if (type == "2") {
      return "sbcg2";
    } else if (type == "3") {
      return "sbyc2";
    } else if (type == "4") {
      return "sbz";
    } else if (type == "5") {
      return "sbz";
    } else if (type == "6") {
      return "sbcg2";
    } else if (type == "20") {
      return "sbcg2";
    } else if (type == "21") {
      return "sbz";
    } else if (type == "22") {
      return "sbcg2";
    } else {
      return "未知状态";
    }
  }
}

// 税种缴款 扣款任务结果状态
export function batchSendKk(status, type) {
  if (status == 0 || status == "") {
    return "未扣款";
  } else if (status == 1) {
    return "排队中";
  } else if (status == 2) {
    return "扣款中";
  } else if (status == 4) {
    return "失败";
  } else {
    if (type == "2") {
      return "成功";
    } else if (type == "3") {
      return "失败";
    } else {
      return "未知状态";
    }
  }
}

// 税种缴款 扣款任务结果状态 字体颜色
export function batchSendWordKk(status, type) {
  if (status == 0 || status == "") {
    return "wsb";
  } else if (status == 1) {
    return "sbz";
  } else if (status == 2) {
    return "sbz";
  } else if (status == 4) {
    return "sbyc2";
  } else {
    if (type == "2") {
      return "sbcg2";
    } else if (type == "3") {
      return "sbyc2";
    } else {
      return "未知状态";
    }
  }
}

// 申报检查任务结果状态
export function batchSendJc(status, type) {
  if (status == 0 || status == "") {
    return "未检查";
  } else if (status == 1) {
    return "排队中";
  } else if (status == 2) {
    return "检查中";
  } else if (status == 4) {
    return "失败";
  } else {
    if (type == "2") {
      return "成功";
    } else if (type == "3") {
      return "失败";
    } else {
      return "未知状态";
    }
  }
}

// 采集发票
export function batchSendCj(status, type) {
  if (status == 0 || status == "") {
    return "未采集";
  } else if (status == 1) {
    return "排队中";
  } else if (status == 2) {
    return "采集中";
  } else if (status == 4) {
    return "失败";
  } else if (status == 8) {
    return "任务已撤销";
  } else {
    if (type == "2") {
      return "成功";
    } else if (type == "3") {
      return "失败";
    } else if (type == "4") {
      return "税局审核中";
    } else if (type == "5") {
      return "成功（未勾选发票）";
    } else {
      return "未知状态";
    }
  }
}

export function batchSendIconCj(status, type) {
  if (status == 0 || status == "") {
    return "iconfont icon-gantanhao";
  } else if (status == 1) {
    return "iconfont icon-info";
  } else if (status == 2) {
    return "iconfont icon-info";
  } else if (status == 4) {
    return "iconfont icon-cuowu";
  } else {
    if (type == "2") {
      return "iconfont icon-duihao";
    } else if (type == "3") {
      return "iconfont icon-cuowu";
    } else if (type == "4") {
      return "iconfont icon-info";
    } else if (type == "5") {
      return "iconfont icon-duihao";
    }
  }
}

// 检查状态
export function setUpStatusJc(status, type) {
  if (type == "task") {
    if (status == 0 || status == "") {
      return "未检查";
    } else if (status == 1) {
      return "排队中";
    } else if (status == 2) {
      return "检查中";
    } else if (status == 3) {
      return "检查完成";
    } else if (status == 4) {
      return "检查失败";
    }
  } else {
    if (status == "2") {
      return "检查通过";
    } else if (status == "3") {
      return "检查失败";
    }
  }
}

export function setUpStatusIconJc(status, type) {
  if (type == "task") {
    if (status == 0 || status == "") {
      return "iconfont icon-gantanhao";
    } else if (status == 1) {
      return "iconfont icon-info";
    } else if (status == 2) {
      return "iconfont icon-info";
    } else if (status == 3) {
      return "iconfont icon-duihao";
    } else if (status == 4) {
      return "iconfont icon-cuowu";
    }
  } else {
    if (status == "2") {
      return "iconfont icon-duihao";
    } else if (status == "3") {
      return "iconfont icon-cuowu";
    }
  }
}

// 个税作废状态
export function setUpStatusGsZf(status, type) {
  if (status == 0 || status == "") {
    return "未作废";
  } else if (status == 1) {
    return "排队中";
  } else if (status == 2) {
    return "申报中";
  } else if (status == 4) {
    return "失败";
  } else {
    if (type == "2") {
      return "成功";
    } else if (type == "3") {
      return "失败";
    }
  }
}

export function setUpStatusGsIconZf(status, type) {
  if (status == 0 || status == "") {
    return "iconfont icon-gantanhao";
  } else if (status == 1) {
    return "iconfont icon-info";
  } else if (status == 2) {
    return "iconfont icon-info";
  } else if (status == 4) {
    return "iconfont icon-cuowu";
  } else {
    if (type == "2") {
      return "iconfont icon-duihao";
    } else if (type == "3") {
      return "iconfont icon-cuowu";
    }
  }
}

export function setUpStatusGsWordZf(status, type) {
  if (status == 0 || status == "") {
    return "wsb";
  } else if (status == 1) {
    return "sbz";
  } else if (status == 2) {
    return "sbz";
  } else if (status == 4) {
    return "sbyc2";
  } else {
    if (type == "2") {
      return "sbcg2";
    } else if (type == "3") {
      return "sbyc2";
    }
  }
}

// 采集科目余额表状态
export function setUpStatusJzCj(status, type) {
  if (status == 0 || status == "") {
    return "未采集";
  } else if (status == 1) {
    return "排队中";
  } else if (status == 2) {
    return "采集中";
  } else if (status == 4) {
    return "失败";
  } else {
    if (type == "2") {
      return "采集成功";
    } else if (type == "3") {
      return "采集失败";
    }
  }
}

export function setUpStatusQS(type) {
  if (type == "0") {
    return "未取数";
  } else if (type == "1") {
    return "排队中";
  } else if (type == "2") {
    return "取数中";
  } else if (type == "3") {
    return "取数完成";
  } else if (type == "4") {
    return "取数失败";
  } else if (type == "5") {
    return "错误";
  }
}

export function setUpStatusQSIcon(type) {
  if (type == "0") {
    return "iconfont icon-gantanhao";
  } else if (type == "1") {
    return "iconfont icon-info";
  } else if (type == "2") {
    return "iconfont icon-info";
  } else if (type == "3") {
    return "iconfont icon-duihao";
  } else if (type == "4") {
    return "iconfont icon-cuowu";
  } else if (type == "5") {
    return "iconfont icon-cuowu";
  }
}

export function setUpStatusJzCjIcon(status, type) {
  if (status == 0 || status == "") {
    return "iconfont icon-gantanhao";
  } else if (status == 1) {
    return "iconfont icon-info";
  } else if (status == 2) {
    return "iconfont icon-info";
  } else if (status == 4) {
    return "iconfont icon-cuowu";
  } else {
    if (type == "2") {
      return "iconfont icon-duihao";
    } else if (type == "3") {
      return "iconfont icon-cuowu";
    }
  }
}

// 城市筛选
export function cityFilter(type) {
  if (type == "beijing") {
    return "北京";
  } else if (type == "shandong") {
    return "山东";
  } else if (type == "qingdao") {
    return "青岛";
  } else if (type == "neimenggu") {
    return "内蒙古";
  } else if (type == "shanxi") {
    return "山西";
  } else if (type == "tianjin") {
    return "天津";
  } else if (type == "sichuan") {
    return "四川";
  } else if (type == "jiangsu") {
    return "江苏";
  } else if (type == "hebei") {
    return "河北";
  } else if (type == "xizang") {
    return "西藏";
  } else if (type == "qinghai") {
    return "青海";
  } else if (type == "henan") {
    return "河南";
  } else if (type == "shaanxi") {
    return "陕西";
  } else if (type == "hainan") {
    return "海南";
  } else if (type == "liaoning") {
    return "辽宁";
  } else if (type == "shanghai") {
    return "上海";
  } else if (type == "hunan") {
    return "湖南";
  } else if (type == "guangdong") {
    return "广东";
  } else if (type == "shenzhen") {
    return "深圳";
  } else if (type == "guangxi") {
    return "广西";
  } else if (type == "chongqing") {
    return "重庆";
  } else if (type == "yunnan") {
    return "云南";
  } else if (type == "xinjiang") {
    return "新疆";
  } else if (type == "anhui") {
    return "安徽";
  } else if (type == "hubei") {
    return "湖北";
  } else if (type == "guizhou") {
    return "贵州";
  } else if (type == "dalian") {
    return "大连";
  } else if (type == "ningbo") {
    return "宁波";
  } else if (type == "xiamen") {
    return "厦门";
  } else if (type == "ningxia") {
    return "宁夏";
  } else if (type == "jiangxi") {
    return "江西";
  } else if (type == "jilin") {
    return "吉林";
  } else if (type == "heilongjiang") {
    return "黑龙江";
  } else if (type == "zhejiang") {
    return "浙江";
  } else if (type == "fujian") {
    return "福建";
  } else if (type == "guizhou") {
    return "贵州";
  } else if (type == "gansu") {
    return "甘肃";
  }
}
//地区code筛选
export function codeFilter(type) {
  if (type == "110000") {
    return "beijing";
  } else if (type == "370000") {
    return "shandong";
  } else if (type == "370200") {
    return "qingdao";
  } else if (type == "150000") {
    return "neimenggu";
  } else if (type == "140000") {
    return "shanxi";
  } else if (type == "120000") {
    return "tianjin";
  } else if (type == "510000") {
    return "sichuan";
  } else if (type == "320000") {
    return "jiangsu";
  } else if (type == "130000") {
    return "hebei";
  } else if (type == "540000") {
    return "xizang";
  } else if (type == "630000") {
    return "qinghai";
  } else if (type == "410000") {
    return "henan";
  } else if (type == "610000") {
    return "shaanxi";
  } else if (type == "460000") {
    return "hainan";
  } else if (type == "210000") {
    return "liaoning";
  } else if (type == "310000") {
    return "shanghai";
  } else if (type == "430000") {
    return "hunan";
  } else if (type == "440000") {
    return "guangdong";
  } else if (type == "440300") {
    return "shenzhen";
  } else if (type == "450000") {
    return "guangxi";
  } else if (type == "500000") {
    return "chongqing";
  } else if (type == "530000") {
    return "yunnan";
  } else if (type == "650000") {
    return "xinjiang";
  } else if (type == "340000") {
    return "anhui";
  } else if (type == "420000") {
    return "hubei";
  } else if (type == "520000") {
    return "guizhou";
  } else if (type == "210200") {
    return "dalian";
  } else if (type == "330200") {
    return "ningbo";
  } else if (type == "350200") {
    return "xiamen";
  } else if (type == "640000") {
    return "ningxia";
  } else if (type == "360000") {
    return "jiangxi";
  } else if (type == "220000") {
    return "jilin";
  } else if (type == "230000") {
    return "heilongjiang";
  } else if (type == "330000") {
    return "zhejiang";
  } else if (type == "350000") {
    return "fujian";
  } else if (type == "620000") {
    return "gansu";
  } else if (type == "beijing") {
    return "110000";
  } else if (type == "shandong") {
    return "370000";
  } else if (type == "qingdao") {
    return "370200";
  } else if (type == "neimenggu") {
    return "150000";
  } else if (type == "shanxi") {
    return "140000";
  } else if (type == "tianjin") {
    return "120000";
  } else if (type == "sichuan") {
    return "510000";
  } else if (type == "jiangsu") {
    return "320000";
  } else if (type == "hebei") {
    return "130000";
  } else if (type == "xizang") {
    return "540000";
  } else if (type == "qinghai") {
    return "630000";
  } else if (type == "henan") {
    return "410000";
  } else if (type == "shaanxi") {
    return "610000";
  } else if (type == "hainan") {
    return "460000";
  } else if (type == "liaoning") {
    return "210000";
  } else if (type == "shanghai") {
    return "310000";
  } else if (type == "hunan") {
    return "430000";
  } else if (type == "guangdong") {
    return "440000";
  } else if (type == "shenzhen") {
    return "440300";
  } else if (type == "guangxi") {
    return "450000";
  } else if (type == "chongqing") {
    return "500000";
  } else if (type == "yunnan") {
    return "530000";
  } else if (type == "xinjiang") {
    return "650000";
  } else if (type == "anhui") {
    return "340000";
  } else if (type == "hubei") {
    return "420000";
  } else if (type == "guizhou") {
    return "520000";
  } else if (type == "dalian") {
    return "210200";
  } else if (type == "ningbo") {
    return "330200";
  } else if (type == "xiamen") {
    return "350200";
  } else if (type == "ningxia") {
    return "640000";
  } else if (type == "jiangxi") {
    return "360000";
  } else if (type == "jilin") {
    return "220000";
  } else if (type == "heilongjiang") {
    return "230000";
  } else if (type == "zhejiang") {
    return "330000";
  } else if (type == "fujian") {
    return "350000";
  } else if (type == "gansu") {
    return "620000";
  } else if (type == "北京") {
    return "beijing";
  } else if (type == "山东") {
    return "shandong";
  } else if (type == "青岛") {
    return "qingdao";
  } else if (type == "内蒙古") {
    return "neimenggu";
  } else if (type == "山西") {
    return "shanxi";
  } else if (type == "天津") {
    return "tianjin";
  } else if (type == "四川") {
    return "sichuan";
  } else if (type == "江苏") {
    return "jiangsu";
  } else if (type == "河北") {
    return "hebei";
  } else if (type == "西藏") {
    return "xizang";
  } else if (type == "青海") {
    return "qinghai";
  } else if (type == "河南") {
    return "henan";
  } else if (type == "陕西") {
    return "shaanxi";
  } else if (type == "海南") {
    return "hainan";
  } else if (type == "辽宁") {
    return "liaoning";
  } else if (type == "上海") {
    return "shanghai";
  } else if (type == "湖南") {
    return "hunan";
  } else if (type == "广东") {
    return "guangdong";
  } else if (type == "深圳") {
    return "shenzhen";
  } else if (type == "广西") {
    return "guangxi";
  } else if (type == "重庆") {
    return "chongqing";
  } else if (type == "云南") {
    return "yunnan";
  } else if (type == "新疆") {
    return "xinjiang";
  } else if (type == "安徽") {
    return "anhui";
  } else if (type == "湖北") {
    return "hubei";
  } else if (type == "贵州") {
    return "guizhou";
  } else if (type == "大连") {
    return "dalian";
  } else if (type == "宁波") {
    return "ningbo";
  } else if (type == "厦门") {
    return "xiamen";
  } else if (type == "宁夏") {
    return "ningxia";
  } else if (type == "江西") {
    return "jiangxi";
  } else if (type == "吉林") {
    return "jilin";
  } else if (type == "黑龙江") {
    return "heilongjiang";
  } else if (type == "浙江") {
    return "zhejiang";
  } else if (type == "福建") {
    return "fujian";
  } else if (type == "贵州") {
    return "guizhou";
  } else if (type == "甘肃") {
    return "gansu";
  }
}

// 汇算清缴取数状态
export function yearAcessStatus(type) {
  if (type == 0) {
    return "未取数";
  } else if (type == 1) {
    return "取数中";
  } else if (type == 3) {
    return "取数成功";
  } else if (type == 4) {
    return "取数失败";
  }
}

export function yearAcessIconStatus(type) {
  if (type == 0) {
    return "iconfont icon-gantanhao";
  } else if (type == 1) {
    return "iconfont icon-info";
  } else if (type == 3) {
    return "iconfont icon-duihao";
  } else if (type == 4) {
    return "iconfont icon-cuowu";
  }
}

export function yearAcessWordStatus(type) {
  if (type == 0) {
    return "wsb";
  } else if (type == 1) {
    return "sbz";
  } else if (type == 3) {
    return "sbcg2";
  } else if (type == 4) {
    return "sbyc2";
  }
}

// 税种申报 申报任务结果状态
export function batchSendYearSb(status, type) {
  if (status == 0 || status == "") {
    return "未申报";
  } else if (status == 1) {
    return "排队中";
  } else if (status == 2) {
    return "申报中";
  } else if (status == 4) {
    return "失败";
  } else {
    if (type == "2") {
      return "申报成功,无需扣款";
    } else if (type == "3") {
      return "申报失败";
    } else if (type == "4") {
      return "提交金三处理中";
    } else if (type == "5") {
      return "申报成功,待缴款";
    } else if (type == "6") {
      return "申报成功,已缴款";
    } else if (type == "20") {
      return "已申报过，无需扣款";
    } else if (type == "21") {
      return "己申报过，待缴款";
    } else if (type == "22") {
      return "已申报过，已缴款";
    } else {
      return "未知状态";
    }
  }
}
export function filterAutoStatusText(type, flag) {
  const statusMap = {
    1: "进行中",
    2: {
      qr: "待确认",
      skqr: "待确认",
      cj: "采集中",
      bc: "补充中",
      sc: "生成中",
      jz: "结账中",
      sb: "申报中",
      kk: "扣款中",
      jc: "检查中",
      zj: "待质检",
      default: "执行中",
    },
    3: {
      qr: "已确认",
      zj: "已确认",
      skqr: "申报并扣款",
      default: "成功",
    },
    4: "失败",
    5: "部分成功",
    6: {
      qr: "无需确认",
      skqr: "无需确认",
      default: "无需操作",
    },
    7: "人工跳过",
    8: "超时确认",
    9: "申报暂不扣款",
    default: {
      qr: "未确认",
      skqr: "未确认",
      zj: "未质检",
      default: "未开始",
    },
  }

  // 获取对应的 status 对象或直接返回字符串
  const statusObj = statusMap[type] || statusMap.default

  // 如果 statusObj 是字符串，则直接返回；如果是对象，则根据 flag 返回对应值
  return typeof statusObj === "string"
    ? statusObj
    : statusObj[flag] || statusObj.default
}

// 基础代账版申报确认状态
export function homeTaxStatus(type) {
  const statusMap = {
    0: "未确认",
    1: "申报并扣款",
    2: "调整税款",
    3: "无需确认",
    4: "税款确认中",
    6: "申报暂不扣款",
  }
  // 返回对应的描述或默认值
  return statusMap[type] || "未知状态"
}

// 首页各确认状态
export function homeConfirmStatus(type, flag) {
  const statusMap = {
    0: `未${flag ? "核查" : "确认"}`,
    1: `已${flag ? "核查" : "确认"}`,
    2: "调整税款",
    3: "无需确认",
    4: "确认中",
  }
  // 返回对应的描述或默认值
  return statusMap[type] || "未知状态"
}
